export const FETCH_DATA_INIT = 'FETCH_DATA_INIT'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE'
export const FETCH_USER_ATTRIBUTES = 'FETCH_USER_ATTRIBUTES'
export const RESET_USER_DATA = 'RESET_USER_DATA'
export const ADD_CARD = 'ADD_CARD'